import Hidden from '@material-ui/core/Hidden';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import React from 'react';

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.error[theme.palette.type],
        '& td': {
            color: theme.palette.error.contrastText,
        },
    },
    message: {
        textAlign: 'center',
    },
}));

const OverlapRow : React.FC = () => {
    const classes = useStyles();

    return (
        <TableRow className={classes.root}>
            <TableCell/>
            <Hidden smDown>
                <TableCell/>
                <TableCell/>
                <TableCell/>
            </Hidden>
            <TableCell colSpan={2}/>
            <TableCell className={classes.message}>
                Rows overlap
            </TableCell>
        </TableRow>
    );
};

export default OverlapRow;
